import {
  TaxonomyMunicipalities,
  TaxonomyThemes,
} from '../implementations';

const mappers = {
  municipalities: TaxonomyMunicipalities,
  themes: TaxonomyThemes,
};

export default mappers;
